import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactDataGrid from 'react-data-grid';
import DataHaulGridProgressBar from './DataHaulGridProgressBar';
import deleteIcon from '../../../images/trash-icon.png';
import downloadExcelIcon from '../../../images/excel-icon.png';
import * as urls from '../../../actions/urlTypes';
import * as datahaulActions from '../../../actions/datahaulActions';
import { DATAHAUL_EXPORT_REPORT } from '../../../constants';

const DeleteButon = ({ value, eventHandler }) => (
  <button
    className="button icon-btn"
    title="Delete"
    onClick={() => eventHandler(value)}
  >
    <img src={deleteIcon} alt="delete" />
  </button>
);

DeleteButon.propTypes = {
  value: PropTypes.number,
  eventHandler: PropTypes.func,
};

const DownloadExcelButton = ({ value, eventHandler }) => (
  <button
    className="button icon-btn"
    title="Download"
    onClick={() => eventHandler(value)}
  >
    <img src={downloadExcelIcon} alt="delete" />
  </button>
);

DownloadExcelButton.propTypes = {
  value: PropTypes.number,
  eventHandler: PropTypes.func,
};

class DataHaulGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { key: 'serialNum', name: '', width: 40, textAlign: 'center' },
        { key: 'title', name: '', editable: true },
        {
          key: 'progress',
          name: 'Progress',
          width: 200,
          formatter: DataHaulGridProgressBar,
        },
        { key: 'status', name: 'Status', width: 140 },
        {
          key: 'download',
          name: 'Actions',
          width: 35,
          formatter: (
            <DownloadExcelButton eventHandler={this.handleDownloadBtn} />
          ),
        },
        {
          key: 'delete',
          name: '',
          width: 35,
          formatter: <DeleteButon eventHandler={this.handleDeleteBtn} />,
        },
      ],
      rows: [],
    };
    this.timerId = -1;
    if (
      props.loginResponse &&
      props.loginResponse.data &&
      props.activeAccountId
    ) {
      props.datahaulActions.getDatahaulReports(
        props.loginResponse.data.uid,
        props.activeAccountId,
      );
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.datahaulReports !== nextProps.datahaulReports) {
      this.setState({
        rows:
          this.searchInput && this.searchInput.value
          ? this.handleSearch(this.searchInput.value, [
            ...nextProps.datahaulReports,
          ])
          : [...nextProps.datahaulReports],
      });
    }
    if (nextProps.isAnyReportInProgress) {
      if (this.timerId < 0) {
        this.poll();
      }
    } else if (this.timerId > 0 && nextProps.isAnyReportInProgress === false) {
      clearInterval(this.timerId);
      this.timerId = -1;
    }
  }

  componentWillUnmount() {
    if (this.timerId !== undefined) {
      clearInterval(this.timerId);
      this.timerId = -1;
    }
  }

  getProgress = row => {
    // check for undfined
    if (row !== undefined && row.status !== undefined) {
      if (row.status === 'Complete') {
        return 100;
      } else if (row.status === 'Processing') {
        return 50;
      } else if (row.status === 'Submitted' || row.status === 'Submited') {
        return 0;
      } else if (row.status === 'Error') {
        return -1;
      }
    }
    return 0;
  };

  handleDeleteBtn = id =>
    this.props.datahaulActions.deleteDatahaulReport(
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      id,
    );

  rowGetter = index => {
    if (index !== -1 && this.state.rows[index]) {
      return {
        ...this.state.rows[index],
        progress: this.getProgress(this.state.rows[index]),
        serialNum: index + 1,
        download: this.state.rows[index].id,
        delete: this.state.rows[index].id,
      };
    }
    return {};
  };

  handleDownloadBtn = reportID => {
    this.props.trackerFn({ action: DATAHAUL_EXPORT_REPORT });
    const link = document.createElement('a');
    document.body.appendChild(link);
    link.href = `${urls.ROOT_URL}/reports/datahaul/${
      this.props.loginResponse.data.uid
    }/${this.props.activeAccountId}/${reportID}`;
    link.click();
  };

  poll = () => {
    this.timerId = setInterval(() => {
      if (
        this.props.loginResponse &&
        this.props.loginResponse.data &&
        this.props.activeAccountId
      ) {
        this.props.datahaulActions.getDatahaulReports(
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
        );
      }
    }, 15000);
  };

  handleGridRowUpdated = ({ fromRow, updated }) => {
    if (updated.title) {
      this.setState({
        rows: this.state.rows.map((item, index) => ({
          ...item,
          title: fromRow === index ? updated.title : item.title,
        })),
      });
      this.props.datahaulActions.renameDatahaulReport(
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        this.state.rows[fromRow].id,
        updated.title,
      );
    }
  };

  handleSearch = (searchTextString, searchData) => {
    const searchTextArray = searchTextString
      .trim()
      .replace(/\s\s+/g, ' ')
      .toLowerCase()
      .split(' ');
    const searchResult = searchData.filter(item => {
      const text = item.title.toLowerCase();
      return (
        searchTextArray.length === 0 ||
        searchTextArray.every(searchText => text.indexOf(searchText) > -1)
      );
    });
    return searchResult;
  };

  handleChange = e =>
    this.setState({
      rows: this.handleSearch(e.target.value, this.props.datahaulReports),
    });

  render() {
    return (
      <div className="datahaul-grid-wrapper">
        <div className="search-box-wrapper">
          <input
            type="text"
            className="search-box-input"
            placeholder="Search"
            onChange={this.handleChange}
            ref={node => (this.searchInput = node)}
          />
        </div>
        <ReactDataGrid
          enableCellSelect
          columns={this.state.columns}
          rowGetter={this.state.rows.length ? this.rowGetter : () => null}
          rowHeight={35}
          rowsCount={
            this.state.rows && this.state.rows.length
              ? this.state.rows.length
              : 0
          }
          minWidth={
            this.props.dataHaulGridWidth === 0
              ? 700
              : this.props.dataHaulGridWidth
          }
          minHeight={
            this.props.dataHaulGridHeight === 0
              ? document.documentElement.clientHeight * 0.7
              : this.props.dataHaulGridHeight
          }
          onGridRowsUpdated={this.handleGridRowUpdated}
        />
      </div>
    );
  }
}

DataHaulGrid.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
    }),
  }),
  activeAccountId: PropTypes.number,
  dataHaulGridWidth: PropTypes.number,
  dataHaulGridHeight: PropTypes.number,
  datahaulReports: PropTypes.arrayOf(PropTypes.object),
  datahaulActions: PropTypes.shape({
    getDatahaulReports: PropTypes.func,
    renameDatahaulReport: PropTypes.func,
    deleteDatahaulReport: PropTypes.func,
  }),
  trackerFn: PropTypes.func,
};

DataHaulGrid.defaultProps = {
  renderEmpty: () => <div />,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    datahaulReports: state.datahaul.datahaulReports,
    isAnyReportInProgress: state.datahaul.isAnyReportInProgress,
    dataHaulPollingInProgress: state.datahaul.dataHaulPollingInProgress,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    datahaulActions: bindActionCreators(datahaulActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataHaulGrid);
